import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useFeatureFlagContext } from '../contexts/FeatureFlagContext';

/**
 * Banner shown when the one-time feature-flag fetch failed every attempt.
 *
 * Without it, a failing `POST /v1/feature-flags/get` looks exactly like "your team has no Pro
 * features": every flag reads false and the gated UI (Split custody, Send Case, Word download,
 * ...) silently disappears with nothing on screen to explain it.
 */
export const FeatureFlagErrorBanner: React.FC = () => {
    const theme = useTheme();
    const { error, isLoading, reload } = useFeatureFlagContext();

    if (!error || isLoading) {
        return null;
    }

    return (
        <div
            role="alert"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 2000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: theme.spacing.sm,
                padding: theme.spacing.sm,
                backgroundColor: theme.colors.status.warning,
                color: theme.colors.text.inverse,
                fontSize: theme.typography.fontSize.sm,
                fontWeight: theme.typography.fontWeight.medium,
            }}
        >
            <i className="fas fa-triangle-exclamation" aria-hidden />
            <span>Some features could not be loaded, so parts of the app are hidden.</span>
            <button
                type="button"
                onClick={reload}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: theme.spacing.xs,
                    background: 'none',
                    border: `1px solid ${theme.colors.text.inverse}`,
                    borderRadius: theme.borderRadius.sm,
                    color: theme.colors.text.inverse,
                    cursor: 'pointer',
                    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                    fontSize: theme.typography.fontSize.sm,
                    fontWeight: theme.typography.fontWeight.medium,
                }}
            >
                <i className="fas fa-rotate-right" aria-hidden />
                Retry
            </button>
        </div>
    );
};
